import React, { Fragment, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Button from "../../atoms/button/button";
import Follows from "../follows/follows";
import {
  normalizeTwoWords,
  findTarget,
  findRel,
} from "../../../shared/utils/stringUtilities";

import "./footer.scss";

const Footer = (props: { isSuperFooter: boolean }) => {
  const data = useStaticQuery(graphql`
    query FOOTER_CONTENT {
      allContentfulHome(filter: { titulo: { eq: "Home bibliotecas" } }) {
        nodes {
          textCentralLlamadas
        }
      }
      allContentfulFooter(filter: { titulo: { eq: "Footer bibliotecas" } }) {
        nodes {
          titulo
          categorias {
            nombreCategoria
            noVisibleFooter
            hyperLink
            referenciaSubcategorias {
              titulo
              slug
              link
              nombreSubcategoria
              tipoCampo
              appStore {
                title
                file {
                  url
                }
              }
              playStore {
                title
                file {
                  url
                }
              }
            }
          }
        }
      }
      allContentfulMenuLoggin(
        filter: { titulo: { eq: "Menu login bibliotecas" } }
      ) {
        nodes {
          logoGray {
            title
            file {
              url
            }
          }
        }
      }
      allContentfulFooterSeccion2(
        filter: { titulo: { eq: "Footer bibliotecas" } }
      ) {
        nodes {
          tituloPrincipal
          descripcion {
            raw
          }
          lgoVigiladosVertical {
            title
            file {
              url
            }
          }
          logoAsojacas {
            title
            file {
              url
            }
          }
          logoRedPactoGlobal {
            title
            file {
              url
            }
          }
        }
      }
    }
  `);

  interface StoreInterface {
    link?: string;
    title: string;
    file: {
      url: string;
    };
  }

  interface FooterInterface {
    nombreCategoria: string;
    noVisibleFooter: boolean;
    hyperLink: string;
    referenciaSubcategorias: {
      titulo: string;
      link: string;
      slug: string;
      nombreSubcategoria: string;
      tipoCampo: string;
      appStore: StoreInterface;
      playStore: StoreInterface;
    }[];
  }

  interface Footer2Interface {
    tituloPrincipal: string;
    descripcion: any;
    lgoVigiladosVertical: StoreInterface;
    logoAsojacas: StoreInterface;
    logoRedPactoGlobal: StoreInterface;
  }

  const titleCallCenter: string =
    data.allContentfulHome.nodes[0].textCentralLlamadas;
  const linkTitleCallCenter: string =
    data.allContentfulHome.nodes[0].redireccionTitulo;
  const queryFooter: FooterInterface[] =
    data.allContentfulFooter.nodes[0].categorias;
  const queryFooter2: Footer2Interface =
    data.allContentfulFooterSeccion2.nodes[0];
  const logoGray = data.allContentfulMenuLoggin.nodes[0].logoGray;

  const [selectIndex, setSelectIndex] = useState(-1);

  const toggleButton = (index: number) => {
    setSelectIndex(selectIndex === index ? -1 : index);
  };

  const getNormalItems = (items: FooterInterface[]) =>
    items.map((val: FooterInterface, index: number) =>
      !val.noVisibleFooter ? (
        <div className="f-container__one" key={`normalItem-${index}`}>
          <span
            className={`f-container__one__title mode-mobile ${
              index === selectIndex ? "mode-mobile__show" : ""
            }`}
            onClick={() => toggleButton(index)}
          >
            {val.nombreCategoria}
          </span>
          <ul className="f-container__one__list">
            {val.referenciaSubcategorias.map((subVal, index) => {
              const gtm = `gtm${normalizeTwoWords(
                val.nombreCategoria
              )}${normalizeTwoWords(subVal.nombreSubcategoria)}`;
              const ref = (subVal.slug && `/${subVal.slug}`) || subVal.link;
              return (
                <li
                  className={`f-container__one__list__li ${gtm}`}
                  key={`normalItemLi-${index}`}
                >
                  <a
                    className={gtm}
                    title={subVal.nombreSubcategoria}
                    href={ref}
                    target={findTarget(ref)}
                    rel={findRel(ref)}
                  >
                    {subVal.nombreSubcategoria}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <></>
      )
    );

  const getCallCenterItems = (
    items: FooterInterface[],
    title: string | null,
    classP: string,
    classTitle: string
  ) => (
    <div className={`f-container__one ${classP}`}>
      {title && linkTitleCallCenter ? (
        <Button
          isDisabled={true}
          type={"link"}
          text={title}
          strictCss={true}
          gtmMark={`gtm${normalizeTwoWords(title)}`}
          href={linkTitleCallCenter}
          classname="f-container__one__title"
        />
      ) : (
        <span className="f-container__one__title">{title}</span>
      )}
      {items.map((val, index) =>
        !val.noVisibleFooter ? (
          <Fragment key={`callCenterItem-${index}`}>
            {val.hyperLink ? (
              <a
                className={`f-container__one__title ${classTitle}`}
                href={val.hyperLink}
                target={findTarget(val.hyperLink)}
                rel={val.hyperLink}
              >
                {val.nombreCategoria}
              </a>
            ) : (
              <span className={`f-container__one__title ${classTitle}`}>
                {val.nombreCategoria}
              </span>
            )}
            <ul className="f-container__one__list">
              {val.referenciaSubcategorias.map((subVal, index) => (
                <li
                  className="f-container__one__list__li"
                  key={`callCenterItemLi-${index}`}
                >
                  <a
                    rel="nofollow noreferrer"
                    title={subVal.nombreSubcategoria}
                    href={`tel:${subVal.nombreSubcategoria.replace(/ /g, "")}`}
                  >
                    <i className="icon-phone" />
                    {subVal.nombreSubcategoria}
                  </a>
                </li>
              ))}
            </ul>
          </Fragment>
        ) : null
      )}
    </div>
  );

  const getCulturaComfamaItems = (items: FooterInterface[]) =>
    items.map((val: FooterInterface, index: number) => (
      <Fragment key={`culturaComfamaItem-${index}`}>
        {!val.noVisibleFooter && (
          <div className="f-container__one">
            <span className="f-container__one__title call">
              {val.nombreCategoria}
            </span>
            <ul className="f-container__one__list">
              {val.referenciaSubcategorias.map((subVal, index) => (
                <Fragment key={`culturaComfamaItemLi-${index}`}>
                  <li className="f-container__one__list__li">
                    {subVal.nombreSubcategoria}
                  </li>
                  <li className="f-container__one__list__imgs">
                    <a
                      className={`gtmHome${normalizeTwoWords(
                        val.nombreCategoria
                      )}AppStore`}
                      title={subVal.appStore.title}
                      href={subVal.appStore.link || "/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={subVal.appStore.file.url}
                        alt={subVal.appStore.title}
                      ></img>
                    </a>
                    <a
                      className={`gtmHome${normalizeTwoWords(
                        val.nombreCategoria
                      )}GooglePlay`}
                      title={subVal.playStore.title}
                      href={subVal.appStore.link || "/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={subVal.playStore.file.url}
                        alt={subVal.playStore.title}
                      ></img>
                    </a>
                  </li>
                </Fragment>
              ))}
            </ul>
          </div>
        )}
      </Fragment>
    ));

  return (
    <footer className="m-footer" id='footer'>
      <div className="f-container">
        {getNormalItems(queryFooter.slice(0, 4))}
        {getCallCenterItems(
          queryFooter.slice(4, 6),
          titleCallCenter,
          "call",
          "title_sub"
        )}
        {getCallCenterItems(
          queryFooter.slice(6, 7),
          titleCallCenter,
          "call call-hide",
          "title_sub"
        )}
        {getCulturaComfamaItems(queryFooter.slice(7, 8))}
        <div className="f-container__one call">
          <Follows query={queryFooter[8]} />
        </div>
      </div>
      <div className="f-final-content">
        <div className="f-final-content__box">
          <span className="f-final-content__box__title">
            {queryFooter2.tituloPrincipal}
          </span>
          <div className="f-final-content__box__imgs">
            <img
              className="f-final-content__box__imgs__img"
              src={queryFooter2.logoAsojacas.file.url}
              alt={queryFooter2.logoAsojacas.title}
            />
            <img
              className="f-final-content__box__imgs__img"
              src={queryFooter2.logoRedPactoGlobal.file.url}
              alt={queryFooter2.logoRedPactoGlobal.title}
            />
          </div>
          <article className="f-final-content__box__body">
            {documentToReactComponents(queryFooter2.descripcion.json)}
          </article>
        </div>
        <div
          className={`f-final-content__zone${
            props.isSuperFooter ? " f-final-content__zone--super" : ""
          }`}
        >
          <img
            className="f-final-content__zone__logo"
            src={logoGray.file.url}
            alt={logoGray.title}
          />
          <div className="f-final-content__zone__final">
            <button
              className="f-final-content__zone__final__button icon-arrow-up"
              onClick={() =>
                scroll({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                })
              }
            />
            <img
              src={queryFooter2.lgoVigiladosVertical.file.url}
              alt={queryFooter2.lgoVigiladosVertical.title}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
